<div class="insta-cards-dialog">
  @if (cards()?.length > 1) {
    <div class="cards-top-indicators">
      @for (item of cards(); track item; let index = $index) {
        <div
          class="card-indicator"
          [class.active]="index <= swiperComponent?.swiper?.activeIndex"
        (click)="swiperComponent?.swiper.slideTo(index)"></div>
      }
    </div>
  }

  <button mat-icon-button class="button d-none d-md-block button--icon button--transparent dialog-close-button" mat-dialog-close>
    <lib-icon icon="x" [size]="24"></lib-icon>
  </button>

  <div class="slider-navigation" [class.d-none]="!swiperComponent?.canSlide()">
    <button
      mat-icon-button
      class="button button--icon button--icon-rounded button--black slider-navigation-button dialog-slider-prev"
      [class.d-none]="swiperComponent?.swiper?.isBeginning"
      (click)="swiperComponent?.swiper?.slidePrev()">
      <lib-icon icon="caret-left"></lib-icon>
    </button>

    <button
      mat-icon-button
      class="button button--icon button--icon-rounded button--black slider-navigation-button dialog-slider-next"
      [class.d-none]="swiperComponent?.swiper?.isEnd"
      (click)="swiperComponent?.swiper?.slideNext()">
      <lib-icon icon="caret-right"></lib-icon>
    </button>
  </div>

  <lib-swiper
    class="dialog-slider"
    [slides]="cards()"
    (slideIndexChange)="slideIndexChange($event)"
    [options]="swiperOptions">

    <ng-template swiperContent let-slide="item" let-index="index">
      <div class="slider-card-container" (click)="swiperComponent?.swiper.slideTo(index)">

        @if (slide) {
          <lib-insta-learn-card
            class="slider-card"
            [theme]="index === swiperComponent?.swiper?.activeIndex ? 'static-header' : 'static-header inactive-card'"
            [item]="slide"
            [topic]="topic"
            [showLike]="true"
            [mediaAutoplay]="index === swiperComponent?.swiper?.activeIndex"
            [mediaEnabled]="true"
            [muted]="muted"
            (navigate)="closeDialog($event)"
            (mutedChanged)="mutedChanged($event)">
            <button
              card-header
              mat-icon-button
              mat-dialog-close
              class="button button--icon d-md-none button--transparent button--white-text button--icon-extra-small">
              <lib-icon icon="x"></lib-icon>
            </button>
          </lib-insta-learn-card>
        } @else {
          <lib-skeleton-loader class="placeholder"></lib-skeleton-loader>
        }

      </div>
    </ng-template>
  </lib-swiper>


</div>